import * as React from 'react';

import { TextField } from '@rematter/ui-web';
import { cn } from '@rematter/ui-web/lib';
import { useAtomValue, useSetAtom } from 'jotai';
import { selectAtom } from 'jotai/utils';
import isEqual from 'lodash/isEqual';

import { $quoteForm } from '../../_state/quoteForm.state';
import { useTranslations } from '../../i18n/useTranslations';
import { QuoteFormState } from '../../types/quote';

type Props = {
  disabled?: boolean;
  className?: string;
};

const quoteFormSelector = (state: QuoteFormState) => ({
  notes: state.notes,
});

export const QuoteNotesForm = ({ disabled = false, className }: Props) => {
  const t = useTranslations();

  const selectedFormAtom = React.useMemo(
    () => selectAtom($quoteForm, quoteFormSelector, isEqual),
    [],
  );

  const form = useAtomValue(selectedFormAtom);
  const updateForm = useSetAtom($quoteForm);

  const handleNotesChange = React.useCallback(
    (value: string) => {
      updateForm((prev) => ({
        ...prev,
        notes: value,
      }));
    },
    [updateForm],
  );

  return (
    <div className={cn('@QuoteNotesForm', 'p-6', className)}>
      <TextField
        label={t.common.labels.notes}
        value={form.notes}
        onChange={handleNotesChange}
        placeholder={t.quotes.detail.notes.placeholder}
        textArea
        isDisabled={disabled}
        className="min-h-[200px]"
      />
      {disabled && !form.notes && (
        <p className="mt-2 text-sm text-neutral/60">
          {t.common.labels.noNotes}
        </p>
      )}
    </div>
  );
};
